import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./trainers.css";
import trainerImg from "../../assets/testingimages/otherimages/ourtraining.jpg";

function Trainers() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="trainers-section">
      <div className="container">

        <section>
          <div className="headlines-for-all" data-aos="fade-up">
            <h4>
              <span>Our </span> Trainers
            </h4>
          </div>
        </section>

        <div className="trainers-content">

          {/* Left text area */}
          <div className="trainers-text">
            <p data-aos="fade-up" data-aos-delay="100">
              At{" "}
              <strong>
                <span className="fazo-fazo"> Fazo Academy </span>
              </strong>
              , we are committed to delivering a{" "}
              <strong>
                comprehensive blend of theoretical knowledge and practical skills
              </strong>{" "}
              in Data Science through our expertise in{" "}
              <strong>industry-focused training</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="200">
              Our <strong>experienced Data Science instructors</strong> specialize in{" "}
              <strong>data analysis, machine learning, and predictive modeling</strong>{" "}
              techniques, ensuring students develop{" "}
              <strong>real-world data science expertise</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="300">
              Students gain hands-on experience with{" "}
              <strong>various Data Science tools and technologies</strong>, including{" "}
              <strong>
                Python, Pandas, NumPy, Machine Learning, SQL, Power BI, and Tableau.
              </strong>
            </p>

            <p data-aos="fade-up" data-aos-delay="400">
              Our <strong>specialized training programs</strong> cover industry-leading
              tools and frameworks like{" "}
              <strong>
                Scikit-learn, TensorFlow, Jupyter Notebook, Matplotlib, Seaborn, and Excel
              </strong>
              , enabling students to become proficient in{" "}
              <strong>data visualization, analytics, and intelligent decision-making</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="500">
              Our <strong>dedicated Data Science trainer</strong> designs personalized
              training modules that include{" "}
              <strong>
                real-time data projects, predictive analytics, dashboard creation, model deployment,
                and interview preparation
              </strong>{" "}
              through hands-on practical sessions.
            </p>
          </div>

          {/* Right image */}
          <div className="trainers-image">
            <img
              src={trainerImg}
              alt="Trainers"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trainers;
